import { Injectable } from '@angular/core';
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { TracksService } from '../../../tracks/services/tracks.service';
import * as TracksActions from '../actions/tracks.actions';
import * as TracksApiActions from '../actions/tracks-api.actions';
import { catchError, mergeMap, switchMap, takeUntil, tap, withLatestFrom } from 'rxjs/operators';
import { from, interval, of } from 'rxjs';
import { Utils } from '../../../shared/utils';
import * as Reducers from '../reducers';
import { Store } from '@ngrx/store';
import { cacheLifeTime } from '../../../shared/config';
import * as moment from 'moment';
import { RouteDetails } from '../../../shared/models/route-details';
import { chunkArray, hasAllElements } from '../../../core/common/functions';

@Injectable()
export class TracksEffects {

  getRoutesSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TracksActions.getRoutesSummary.type),
      switchMap((action) => {
        let dateTo: any = action['dateTo'];
        if (moment().isBefore(moment(dateTo))) {
          dateTo = moment().utc().subtract(1, 's').format();
        }
        const params: any = {unitIds: action['unitIds'], dateFrom: action['dateFrom'], dateTo: dateTo};
        return from(chunkArray(action['unitIds'], 5)).pipe(
          mergeMap((unitIds: number[]) => this.tracksService.getRoutes(unitIds, action['dateFrom'], action['dateTo'])
            .pipe(
              switchMap((routes) => {
                routes.forEach((route: RouteDetails) => route.uuid = this.utils.uuid());
                return of(TracksApiActions.getRoutesSummarySuccess({data: routes, params: params, unitIds}));
              }),
              catchError(error => of(TracksApiActions.getRoutesSummarySuccess({data: null, params: params, unitIds})))
            ))
        )

      })
    )
  );

  @Effect()
  clear = interval(cacheLifeTime).pipe(
    switchMap((action) => of(TracksActions.clearRoutesCache()))
  );

  private utils: Utils;
  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private tracksService: TracksService,
  ) {
    this.utils = new Utils();
  }
}
